<template>
  <label class="custom-checkbox">
    <input
      type="checkbox"
      v-bind="$attrs"
      :id="id"
      :value="value"
      :class="{ failed: error }"
      @change="
        $emit(
          'update:modelValue',
          $event.target.checked ? $event.target.value || 'true' : null
        )
      "
    />

    <a :href="link" target="_blank" v-if="link"
      >{{ label }}<span v-if="required">*</span>
    </a>
    <template v-else> {{ label }}<span v-if="required">*</span></template>
  </label>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'BooleanField',
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    modelValue: String
  },
  emits: ['update:modelValue'],
  setup(props) {
    const required = computed(() => {
      return props.rules.includes('required');
    });

    return {
      required
    };
  }
};
</script>
